import React from 'react';
import { useNavigate } from 'react-router-dom';
import AuthBackground from '../../components/AuthBackground';
import ScreenContainer from '../../components/ScreenContainer';
import Heading from '../../components/Heading';
import Text from '../../components/Text';
import Button from '../../components/Button';

const PasswordUpdated = () => {
  const navigate = useNavigate();

  return (
    <>
      <AuthBackground />
      <ScreenContainer>
        <div className="bg-white rounded-3xl shadow-xl p-8 text-center">
          <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <svg className="w-12 h-12 text-green-600" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"/>
            </svg>
          </div>
          <Heading size="lg" className="mb-3">Successful!</Heading>
          <Text>Congratulations! Your password has been changed. Click continue to login.</Text>
          <Button 
            fullWidth
            onClick={() => navigate('/auth')}
            className="mt-8"
          >
            Continue
          </Button>
        </div>
      </ScreenContainer>
    </>
  );
};

export default PasswordUpdated;